<template>
  <div class="bg">
    <div class="infoWrapper">
      <div class="infoLine flex">
        <div class="infoTitle">真实姓名</div>
        <div class="infoText flex1">
          <input placeholder="请输入" v-model="params.realName" />
        </div>
      </div>
      <div class="infoLine flex">
        <div class="infoTitle">身份证号</div>
        <div class="infoText flex1">
          <input placeholder="请输入" v-model="params.idCardNumber" />
        </div>
      </div>
    </div>
    <div class="idCardBox">
      <div class="idCard1">
        <uploadImg
          class="uploadWrapper"
          v-model="params.idCardSurfaceUrl"
        ></uploadImg>
      </div>
      <div class="idCardText">上传身份证人像面照片</div>
      <div class="idCard2">
        <uploadImg
          class="uploadWrapper"
          v-model="params.idCardEmblemUrl"
        ></uploadImg>
      </div>
      <div class="idCardText">上传身份证国徽面照片</div>
    </div>
    <div class="nextButton" @click="identity">认证</div>
  </div>
</template>

<script>
import uploadImg from "@/components/uploadImg/uploadImg.vue";
import { approve, approveInfo } from "../../api/client.js";

export default {
  components: { uploadImg },
  data() {
    return {
      params: {
        realName: "",
        idCardNumber: "",
        idCardSurfaceUrl: "",
        idCardEmblemUrl: ""
      }
    };
  },
  created() {
    approveInfo().then(res => {
      this.params.realName = res.realName;
      this.params.idCardNumber = res.idCardNumber;
      this.params.idCardSurfaceUrl = res.idCardSurfaceUrl;
      this.params.idCardEmblemUrl = res.idCardEmblemUrl;
    });
  },
  methods: {
    identity() {
      let that = this;
      if (!this.params.realName) {
        this.$showError("请输入真实姓名");
      } else if (!this.params.idCardNumber) {
        this.$showError("请输入身份号");
      } else if (!this.params.idCardSurfaceUrl) {
        this.$showError("请上传身份证人像面");
      } else if (!this.params.idCardEmblemUrl) {
        this.$showError("请上传身份证国徽面");
      } else {
        let result = confirm("授权提示：您提供的信息将提供给e签宝，由其提供账户相关服务。");
        if (result) {
          this.$vux.loading.show();
          approve(this.params).then(() => {
              this.$vux.loading.hide();
              if (that.$route.query.from == "cardList") {
                this.$router.go(-1);
              } else if (that.$route.query.from == "bankCardList") {
                this.$router.go(-1);
              } else if (that.$route.query.from == "index") {
                this.$router.push({ path: "/bankCard/addClientBankCard" });
              } else {
                this.$router.push({ path: "/user/userInfo" });
              }
            })
            .catch(err => {
              this.$vux.loading.hide();
              this.$showError(err);
            });
        }
      }
    }
  }
};
</script>

<style>
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
input {
  width: 100%;
  border: none;
  background: #fff;
}
.uploadWrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
}
.bg {
  background: #f3f3f3;
}

.idCardBox {
  background: #fff;
  overflow: hidden;
  padding: 60px 0;
}
.idCard1 {
  width: 550px;
  height: 350px;
  background: url(../../assets/idCard1.jpg);
  background-size: 100% 100%;
  display: block;
  margin: 0 auto;
  position: relative;
}
.idCard2 {
  width: 550px;
  height: 350px;
  background: url(../../assets/idCard2.jpg);
  background-size: 100% 100%;
  display: block;
  margin: 0 auto;
  position: relative;
}
.infoWrapper {
  margin: 20px 0;
  overflow: hidden;
}
.infoLine {
  padding: 30px;
  background: #fff;
  border-bottom: 1px solid #f1f1f1;
}
.infoTitle {
  width: 140px;
  font-size: 14px;
  color: #474747;
  position: relative;
}
.idCardText {
  font-size: 14px;
  color: #ababab;
  text-align: center;
  line-height: 90px;
}
.infoText input {
  font-size: 14px;
  line-height: 28px;
  width: 100%;
  text-align: right;
}
.nextButton {
  margin-top: 44px;
  width: 100%;
  height: 100px;
  line-height: 100px;
  font-size: 16px;
  color: #fff;
  background: #2b80fe;
  text-align: center;
}
</style>
